import { Controller } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"
import { useClickOutside } from 'stimulus-use'

// Connects to data-controller="towns-suggestions"
export default class extends Autocomplete {
  static targets = [...this.targets, 'istatCode', 'districtCode', 'districtName', 'regionName', 'postalCode', 'postalCodes', 'countryCode']

  connect() {
    super.connect()
    useClickOutside(this)

    this.inputTarget.addEventListener("input", this.onInputChangeCustom)

    this.postalCodeTarget.addEventListener("focus", this.onFocusPostalCode)
    this.postalCodeTarget.addEventListener("blur", this.onBlurPostalCode)
  }

  // metodo per pulire i campi nel momento in cui viene fatto il click all'esterno
  clickOutside(event) {
    if (this.hiddenTarget.value == null || this.hiddenTarget.value == '' || this.hiddenTarget.value == undefined) {
      this.inputTarget.value = ''
      this.istatCodeTarget.value = ''
      this.districtNameTarget.value = ''
      this.districtCodeTarget.value = ''
      this.regionNameTarget.value = ''
    }
  }

  // sovrascivo il metodo commit, eseguendo l'originale e andando poi a prendere i campi data per popolare le altre celle
  commit(selected) {
    super.commit(selected)
    this.istatCodeTarget.value = selected.dataset['autocompleteIstatTownCode']
    this.districtNameTarget.value = selected.dataset['autocompleteDistrictName']
    this.districtCodeTarget.value = selected.dataset['autocompleteDistrictCode']
    this.regionNameTarget.value = selected.dataset['autocompleteRegionName']

    // recupero la lista dei CAP e li inserisco nella relativa lista
    fetch(`/towns/postal_codes?itc=${selected.dataset['autocompleteIstatTownCode']}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then((response) => {
      response.text().then((html) => {
        this.postalCodesTarget.insertAdjacentHTML('beforeend', html)
      })
    })
  }

  // metodo per ripulire i campi correlati nel momento in cui viene modificato il comune
  onInputChangeCustom = () => {
    if (this.hasHiddenTarget) {
      this.istatCodeTarget.value = ''
      this.districtNameTarget.value = ''
      this.districtCodeTarget.value = ''
      this.regionNameTarget.value = ''
      this.postalCodeTarget.value = '';
      this.postalCodesTarget.innerHTML = '';
      this.postalCodesTarget.classList.add('hidden')
    }
  }

  // metodo per selezionare un CAP e chiudere la lista
  selectPostalCode(event) {
    this.postalCodeTarget.value = event.target.dataset['autocompleteValue']
    this.postalCodesTarget.classList.add('hidden')
  }

  // sul focus del campo del CAP apro la lista di suggerimenti
  onFocusPostalCode = () => {
    this.postalCodesTarget.classList.remove('hidden')
  }

  // sulla perdita del focus del campo del CAP nascondo la lista di suggerimenti dopo un ritardo per far sì che possa funzionare l'eventuale click
  onBlurPostalCode = () => {
    if (this.countryCodeTarget.value == 'IT') {
      this.postalCodeTarget.value = this.postalCodeTarget.value.replace(/[^0-9]/g, '')
      if (this.postalCodeTarget.value.length != 5) { this.postalCodeTarget.value = '' }
    }
    setTimeout(() => { this.postalCodesTarget.classList.add('hidden') }, 300)
  }
}
